import { getAssetsPageRoute, PageRoutes, UserCenterRoutes } from '@/constants/PageRoutes.ts'
import { APP_CONFIG } from '@/project-config'
import { useUserInfoStore } from 'store'
import { H5BillIcon, MobileAccountIcon, MobileTradeIcon, OrderIcon } from 'ui-components'
import type { VNode } from 'vue'
import { h } from 'vue'

type UserMenu = {
  title: string
  path: string
  icon?: VNode
}

type AsideMenuItem = {
  title: string
  icon?: VNode
  path?: string
  children?: AsideMenuItem[]
}

export default function useUserCommon() {
  const router = useRouter()
  const userInfoStore = useUserInfoStore()

  const onLogout = () => {
    userInfoStore.logout()
    router.replace(PageRoutes.Home)
  }

  const onUserMenuClick = (menu: UserMenu) => {
    router.push(menu.path)
  }

  const kycMenuList = computed(() => {
    if (!APP_CONFIG.isKYC) return []
    return [
      {
        title: '身份认证',
        path: getAssetsPageRoute(UserCenterRoutes.RealNameAuth),
      },
    ]
  })

  const menuList = computed<AsideMenuItem[]>(() => {
    return [
      {
        title: '账户',
        path: 'account',
        icon: h(MobileAccountIcon),
        children: [
          {
            title: '个人概览',
            path: getAssetsPageRoute(UserCenterRoutes.UserOverview),
          },
          ...kycMenuList.value,
          {
            title: '安全设置',
            path: getAssetsPageRoute(UserCenterRoutes.SecuritySettings),
          },
        ],
      },
      {
        title: '资产',
        path: 'assets',
        icon: h(MobileTradeIcon),
        children: [
          // {
          //   title: '资产总览',
          //   path: '/user-center/asset-overview',
          // },
          {
            title: '资金账户',
            path: getAssetsPageRoute(UserCenterRoutes.AssetFund),
          },
          {
            title: '合约账户',
            path: getAssetsPageRoute(UserCenterRoutes.AssetContract),
          },
          {
            title: '理财',
            path: getAssetsPageRoute(UserCenterRoutes.AssetFinance),
          },
          // {
          //   title: '衍生品账户',
          //   path: getAssetsPageRoute(UserCenterRoutes.AssetDerivative),
          // },
          {
            title: '充值',
            path: getAssetsPageRoute(UserCenterRoutes.Recharge),
          },
          {
            title: '提币',
            path: getAssetsPageRoute(UserCenterRoutes.Withdraw),
          },
        ],
      },
      ...(APP_CONFIG.isExchange
        ? [
            {
              title: '订单',
              icon: h(OrderIcon),
              path: 'order',
              children: [
                {
                  title: '现货订单',
                  path: getAssetsPageRoute(UserCenterRoutes.SpotOrder),
                },
                {
                  title: '合约订单',
                  path: getAssetsPageRoute(UserCenterRoutes.ContractOrder),
                },
                {
                  title: '理财历史',
                  path: getAssetsPageRoute(UserCenterRoutes.FinancialHistory),
                },
              ],
            },
          ]
        : []),
      {
        title: '账单',
        icon: h(H5BillIcon),
        path: getAssetsPageRoute(UserCenterRoutes.AssetBill),
      },
      // {
      //   title: '推广中心',
      //   path: getAssetsPageRoute(UserCenterRoutes.PromotionCenter),
      //   icon: h(PromotionCenterIcon),
      // },
      // {
      //   title: '推广中心',
      //   path: getAssetsPageRoute(UserCenterRoutes.PromotionCenter),
      //   icon: (
      //     <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      //       {getPath(
      //         'M1 2.13684C1 1.83533 1.11888 1.54617 1.33049 1.33297C1.54209 1.11977 1.82909 1 2.12835 1H14.9163C15.2155 1 15.5025 1.11977 15.7141 1.33297C15.9258 1.54617 16.0446 1.83533 16.0446 2.13684V9.59263C13.6435 9.24256 11.2458 10.2518 9.80546 12.2188C8.36508 14.1859 8.11553 16.7918 9.15607 19H3.82087C2.26295 19 1 17.7275 1 16.1579V2.13684ZM3.82087 4.26842V5.40526C3.82087 5.61368 3.99012 5.78421 4.19698 5.78421H11.9074C12.0071 5.78421 12.1028 5.74429 12.1733 5.67322C12.2438 5.60215 12.2835 5.50577 12.2835 5.40526V4.26842C12.2835 4.16792 12.2438 4.07153 12.1733 4.00046C12.1028 3.9294 12.0071 3.88947 11.9074 3.88947H4.19698C4.09723 3.88947 4.00157 3.9294 3.93103 4.00046C3.8605 4.07153 3.82087 4.16792 3.82087 4.26842ZM3.82087 9.15021V8.01337C3.82087 7.80408 3.98926 7.63442 4.19698 7.63442H8.1462C8.24595 7.63442 8.34162 7.67435 8.41216 7.74541C8.48269 7.81648 8.52232 7.91287 8.52232 8.01337V9.15021C8.52232 9.25071 8.48269 9.3471 8.41216 9.41817C8.34162 9.48923 8.24595 9.52916 8.1462 9.52916H4.19698C3.99012 9.52916 3.82087 9.35863 3.82087 9.15021Z',
      //       )}
      //       {getPath(
      //         'M18.8697 14.216L16.0048 11.6482C15.7877 11.4342 15.5273 11.6482 15.5273 11.9906V13.2745C13.487 13.2745 11.7507 14.5156 10.9259 16.1847C10.6221 16.741 10.4484 17.3402 10.3182 17.9393C10.2314 18.3673 10.8825 18.5813 11.143 18.1961C12.098 16.6982 13.7041 15.7139 15.5273 15.7139V17.1262C15.5273 17.4686 15.7877 17.6826 16.0048 17.4686L18.8697 14.9008C19.0434 14.7296 19.0434 14.3872 18.8697 14.216Z',
      //         {
      //           opacity: 0.4,
      //         },
      //       )}
      //     </svg>
      //   ),
      // },
    ]
  })

  const getUid = computed(() => userInfoStore.userInfo?.userInfo?.userId)

  const avatar = computed(() => {
    return userInfoStore.userInfo?.userInfo?.avatar
  })

  const vipLevel = computed(() => userInfoStore.userInfo?.userInfo?.btVipLevel)

  const username = computed(() => {
    return userInfoStore.userInfo?.accountInfo.username || userInfoStore.userInfo?.accountInfo.email || userInfoStore.userInfo?.accountInfo.mobile
  })

  return {
    avatar,
    getUid,
    onLogout,
    username,
    menuList,
    vipLevel,
    onUserMenuClick,
  }
}
